export default "__VITE_ASSET__a0fa9b6c__"